import axiosClient, { AxiosInstance } from 'axios';

const TIMEOUT = 35000; //15sec
const SERVER_URL = process.env.REACT_APP_API_HOST || 'http://127.0.0.1:8080';
//const SERVER_URL = process.env.REACT_APP_API_HOST || 'http://7xhzpen6r3xghxap15053.cleavr.xyz/';

const axios: AxiosInstance = axiosClient.create({
  baseURL: SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  //   params: clean({
  //     t: new Date().getTime(),
  //     sub_id: getCookie('sub_id'),
  //   }),

  timeout: TIMEOUT,
  // transformResponse: (res) => transformKeys.toCamelCase(JSON.parse(res)),
});

// const refreshToken = async () => {
//   try {
//     const refreshTokenString = store.getState().user.refreshToken;

//     if (refreshTokenString) {
//       const payload = { refresh: refreshTokenString };
//       const endPoint = 'api/token/refresh/';
//       const res = await axios.post(endPoint, payload);
//       return res.data;
//     }
//   } catch (e) {
//     console.log('Error', e);
//   }
// };

axios.interceptors.request.use(
  async (config) => {
    // const token = store.getState()?.user?.token;
    // if (token && config?.headers) {
    //   config.headers['Authorization'] = 'Bearer ' + token;
    // }
    // config.headers['x-api-key'] = process.env.REACT_APP_TITLE_X_KEY || '9KVvI9QM_98vtE__EYrhCgxFad-6do8fRB9050923uc';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async function () {
    // const originalRequest = error.config;
    // if (originalRequest.url.includes('refresh') && error.response.status === 401) {
    //   message.error('Session expired, please login again!');
    //   store.dispatch(logout());
    // } else if ((error?.response?.status === 403 || error?.response?.status === 401) && !originalRequest._retry) {
    //   originalRequest._retry = true;
    // //   const res = await refreshToken();
    //   store.dispatch(setToken(res.access));
    //   axios.defaults.headers.common['Authorization'] = `Bearer ${res.access}`;
    //   return axios(originalRequest);
    // }
    // return Promise.reject(error);
  },
);

export default axios;
